import type { Enums } from "@msuite/utils/types";
import { create } from "zustand";

interface IInvoiceFilterStore {
	state: Enums<"outgoingInvoiceState"> | "all";
	setState: (state: Enums<"outgoingInvoiceState"> | "all") => void;
}

export const useInvoiceFilterStore = create<IInvoiceFilterStore>((set) => ({
	state: "all",
	setState: (state) => set(() => ({ state })),
}));
